import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRealEstateProjectStats } from 'redux/realEstateSlice';
import MarketShare from './MarketShare';
import PropTypes from 'prop-types';

const WidgetProjectStats = ({ title, cardClasses }) => {
  // * States
  const dispatch = useDispatch();
  const { realEstate, realEstateProjStats } = useSelector(
    state => state.realEstate
  );

  const [data, setData] = useState();

  // * Life Cycle
  useEffect(() => {
    realEstate?.id && dispatch(getRealEstateProjectStats(realEstate.id));
  }, [realEstate]);

  useEffect(() => {
    realEstateProjStats &&
      setData([
        {
          id: 1,
          value: realEstateProjStats.published,
          name: 'Publicadas',
          color: 'success'
        },
        {
          id: 2,
          value: realEstateProjStats.pending,
          name: 'Pendientes',
          color: 'primary'
        },
        {
          id: 3,
          value: realEstateProjStats.paused,
          name: 'Pausadas',
          color: 'warning'
        }
      ]);
  }, [realEstateProjStats]);

  return (
    <>
      {data && (
        <MarketShare
          data={data}
          now={
            realEstateProjStats?.published +
            realEstateProjStats?.pending +
            realEstateProjStats?.paused
          }
          radius={['100%', '80%']}
          cardClasses={cardClasses}
          title={title}
        />
      )}
    </>
  );
};

WidgetProjectStats.propTypes = {
  cardClasses: PropTypes.string,
  title: PropTypes.string
};

export default WidgetProjectStats;
